// extracted by mini-css-extract-plugin
export default {"main":"procedura_main__XJ84v","closeButton":"procedura_closeButton__5W+CJ","online":"procedura_online__cYaWz","fisico":"procedura_fisico__i+wgh","data":"procedura_data__Oy3Rx"};